module.exports = __webpack_public_path__ + "@/assets/img/014-girl-7.024a6e2e.svg";